import { useEffect } from 'react'
import { useUi } from '../store/ui'

const STYLES: Record<string, string> = {
  error: 'border-rose-300 bg-rose-50 text-rose-900',
  info: 'border-blue-300 bg-blue-50 text-blue-900',
  success: 'border-emerald-300 bg-emerald-50 text-emerald-900',
}

const GLYPHS: Record<string, string> = { error: '✕', info: 'i', success: '✓' }

export function Toasts() {
  const toasts = useUi((state) => state.toasts)
  const dismiss = useUi((state) => state.dismissToast)

  useEffect(() => {
    if (toasts.length === 0) return
    const timers = toasts
      .filter((toast) => toast.kind !== 'error')
      .map((toast) => window.setTimeout(() => dismiss(toast.id), 6000))
    return () => timers.forEach(window.clearTimeout)
  }, [toasts, dismiss])

  return (
    <div
      className="pointer-events-none fixed bottom-3 right-3 z-50 flex w-96 flex-col gap-2"
      role="status"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto flex items-start gap-2 rounded-md border px-3 py-2 text-xs shadow-lg ${STYLES[toast.kind]}`}
        >
          <span aria-hidden="true" className="mt-px font-bold">
            {GLYPHS[toast.kind]}
          </span>
          <span className="flex-1">{toast.text}</span>
          <button
            className="btn-icon h-4 w-4 text-current"
            onClick={() => dismiss(toast.id)}
            aria-label="Dismiss notification"
          >
            <span aria-hidden="true">✕</span>
          </button>
        </div>
      ))}
    </div>
  )
}
